import { heroStats } from '@/mocks/movies';

const quickJumps = [
  { href: '#featured', label: '今日精选', icon: 'ri-sparkling-2-line' },
  { href: '#ranking', label: '高分榜单', icon: 'ri-trophy-line' },
  { href: '#latest', label: '最新大片', icon: 'ri-movie-2-line' },
  { href: '#genres', label: '分类找片', icon: 'ri-filter-3-line' },
];

export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[640px] w-full items-center overflow-hidden md:min-h-[92vh]">
      <img
        src="https://readdy.ai/api/search-image?query=cinematic%20dark%20movie%20theater%20interior%20with%20glowing%20screen%20and%20rows%20of%20empty%20red%20seats%2C%20dramatic%20ambient%20lighting%2C%20deep%20atmospheric%20shadows%2C%20subtle%20amber%20highlights%2C%20wide%20panoramic%20composition%2C%20film%20grain%20texture&width=1920&height=1080&seq=sm-hero-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/55 to-black/75" aria-hidden="true" />

      <div className="relative z-10 mx-auto w-full max-w-[1200px] px-4 py-28 md:px-8 md:py-32">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 font-label text-xs md:text-sm font-medium text-accent-300 backdrop-blur-sm">
          <i className="ri-fire-line" aria-hidden="true" />
          神马电影 · 每日更新精选片单
        </span>

        <h1 className="mt-6 max-w-3xl font-heading text-3xl font-black leading-tight text-background-50 md:text-6xl">
          神马电影，找一部真正想看的
        </h1>

        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-lg">
          最新大片、高分排行榜与口碑佳作在这里一次看全。无论你想找一部慢下来的剧情片，还是只想痛快刷一场爆米花爽片，
          都能在三步之内定位到下一部要看的电影。
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
          <a
            href="#featured"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 font-label text-sm font-bold text-foreground-950 transition-colors duration-200 hover:bg-accent-400"
          >
            <i className="ri-play-circle-line text-lg" aria-hidden="true" />
            查看今日精选
          </a>
          <a
            href="#ranking"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/50 px-6 py-3 font-label text-sm font-semibold text-background-50 transition-colors duration-200 hover:bg-background-50/10"
          >
            <i className="ri-trophy-line text-lg" aria-hidden="true" />
            浏览排行榜
          </a>
        </div>

        <div className="mt-8 flex flex-wrap gap-2">
          {quickJumps.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/5 px-4 py-2 font-label text-xs font-medium text-background-100 backdrop-blur-sm transition-colors duration-200 hover:border-accent-400 hover:text-accent-300 md:text-sm"
            >
              <i className={item.icon} aria-hidden="true" />
              {item.label}
            </a>
          ))}
        </div>

        <dl className="mt-10 grid max-w-3xl grid-cols-2 gap-x-6 gap-y-5 border-t border-background-50/20 pt-8 md:grid-cols-4">
          {heroStats.map((stat) => (
            <div key={stat.label} className="flex flex-col gap-1">
              <dt className="font-heading text-xl font-black text-accent-400 md:text-3xl">{stat.value}</dt>
              <dd className="font-label text-xs text-background-100/80 md:text-sm">{stat.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}